<template>

  <div>
    <div class="star-rating">
      <div class="star-mask" :style="{ 'width': width }"></div>
      <div class="star-base"></div>
    </div>
    <div class="text-muted">{{ label }}</div>
  </div>

</template>

<script>
export default {
  name: 'StarsScore',
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
    }
  },
  computed: {
    label () {
      const score = 5 * this.value
      const scoreStr = score.toFixed(2)
      return `${scoreStr}/5`
    },
    width () {
      const val = Math.round(this.value * 100) * 0.833
      return `${val}%`
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.star-rating {
  position: relative;
  display: inline-block;
  width: calc(5 * 20px); /* 5 estrelas de 30px cada */
  height: 20px;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 1;
  direction: ltr;
}

.star-base,
.star-mask {
  position: absolute;
  top: 0;
  left: 0;
  white-space: nowrap;
  overflow: hidden;
}

.star-base {
  color: #ccc; /* Cor das estrelas vazias */
  width: 100%;
  z-index: 0;
}

.star-mask {
  color: #000000; /* Cor das estrelas preenchidas */
  z-index: 1;
}

.star-base::before,
.star-mask::before {
  content: "★★★★★";
}
</style>



// WEBPACK FOOTER //
// src/components/Parts/StarsScore.vue